module.exports = {"140123100":"娄烦镇","140123101":"静游镇","140123102":"杜交曲镇","140123200":"庙湾乡","140123201":"马家庄乡","140123202":"盖家庄乡","140123203":"米峪镇乡","140123204":"天池店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140123.json
// module id = 267
// module chunks = 0